import React from "react";


import { connect } from "react-redux";
import './bankToBank.css';


class BankToBankDetails extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
		
		}
    }

	
    componentDidMount(){}
	componentWillUnmount(){
    }


    render(){
    console.log('Inside render');
    return(
        <div class="col-12 col-lg-4">
        <div class="card">
            <div class="dashhead">
                <h3>Bank-to-Bank Transfer Details</h3>
            </div>
            
            <div class="btbtnsfr">							
                <p>Now you can load money in your corporate virtual account through NEFT/RTGS as per process shown below.</p>
                
                <p>Account Details for adding Payee as mentioned as below:</p>
                
                <div></div>
                
                <div class="table-responsive">
                    <table class="table table-bordered">
                        <thead>
                        <tr>
                            <td>Payee Name:</td>
                            <td>FinXpay Solutions Pvt. Ltd.</td>
                        </tr>
                        <tr>
                            <td>Account Number:</td>
                            <td>FINXPAY4248795778</td>
                        </tr>
                        <tr>
                            <td>Bank Name:</td>
                            <td>Yes Bank Ltd.</td>
                        </tr>
                        <tr>
                            <td>Bank IFSC Code:</td>
                            <td>YESB0CMSNOC</td>
                        </tr>
                        <tr>
                            <td>Account Type:</td>
                            <td>Current Account</td>
                        </tr>
                        </thead>
                    </table>							
                </div>
            </div>					
        </div>
    </div>
				
			
				
			
		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(BankToBankDetails);
